import React from 'react';
import Home from './home-container';

const ProvidedHomeContainer = () => (
  <Home />
);

export default ProvidedHomeContainer;
